enum AssemblyStatusesEnum {
  INCOMPLETE = 'INCOMPLETE',
  PROCESSING = 'PROCESSING',
  CONFIRMED = 'CONFIRMED',
  CANCELED = 'CANCELED',
}

export default AssemblyStatusesEnum;
